import { Search } from 'lucide-react'
import * as React from 'react'
import { Input, type InputProps } from '../atoms/Input'

/**
 * SearchBar — Input pre-wired with a search icon. Pencil Jmpyv.
 */
export interface SearchBarProps extends Omit<InputProps, 'leftIcon' | 'type'> {}

export const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(
  ({ placeholder = 'Search…', ...props }, ref) => (
    <Input
      ref={ref}
      type="search"
      leftIcon={Search}
      placeholder={placeholder}
      clearable
      {...props}
    />
  ),
)
SearchBar.displayName = 'SearchBar'
